import script from "./AuthorizedBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthorizedBtn.vue?vue&type=script&lang=ts&setup=true"

import "./AuthorizedBtn.vue?vue&type=style&index=0&id=03d49080&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d49080"]])

export default __exports__